import * as React from 'react';

import 'css!./__styles__/LoadingSpinner';

/** AI-Generated Documentation - Please Read with Caution */

/**
 * A simple loading spinner component that displays "Loading..." text
 * with spinner styling.
 */
class LoadingSpinner extends React.Component {
  render() {
    return <div className="loading-spinner">Loading...</div>;
  }
}

export default LoadingSpinner;
